// SPDX-License-Identifier: AGPL-3.0-or-later

import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

interface RoleDeleteFailedModalProps {
	roleName: string;
}
export const RoleDeleteFailedModal = observer(({roleName}: RoleDeleteFailedModalProps) => {
	const {t} = useLingui();
	return (
		<GenericErrorModal
			title={t`Failed to Delete Role`}
			message={
				<Trans>
					The role <strong>"{roleName}"</strong> could not be deleted at this time. Please try again.
				</Trans>
			}
		/>
	);
});
